import { isValidBase } from '../BaseEntity';
export const isValidPulseTemplate = properties => {
  return isValidBase(properties);
};
//# sourceMappingURL=PulseTemplate.js.map